import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { Group } from '@core/interfaces';
import { isFilteredBy } from '@core/utils/is-filtered-by';
import { chain } from 'lodash';
import { merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'linked-groups',
  templateUrl: './linked-groups.component.html',
  styleUrls: ['../tab-groups.component.scss']
})
export class LinkedGroupsComponent implements OnInit {
  @Input() public linkedGroups: FormArray;
  @Input() public searchInput: FormControl;
  @Input() public isViewMode: boolean;

  public filteredLinkedGroups: Group[];
  public lastPaginatedLinkedGroupIndex: number;
  public firstPaginatedLinkedGroupIndex: number;

  public ngOnInit(): void {
    this.setDefaultPaginate();
    this.filterLinkedGroups();

    merge(
      this.searchInput.valueChanges,
      this.linkedGroups.valueChanges
    )
      .pipe(debounceTime(300))
      .subscribe(() => this.filterLinkedGroups());
  }

  private filterLinkedGroups(): void {
    this.filteredLinkedGroups = chain(this.linkedGroups.value)
      .filter((group) => isFilteredBy({
        referenceValues: [group.name, group.description],
        includeValue: this.searchInput.value
      }))
      .sortBy('name')
      .value();
  }

  private setDefaultPaginate (): void {
    this.lastPaginatedLinkedGroupIndex = 5;
    this.firstPaginatedLinkedGroupIndex = 1;
  }

  public unlinkGroup(linkedGroup: Group, filteredLinkedGroupIndex: number): void {
    const linkedGroupIndex = this.linkedGroups.value.findIndex((group) => group.id === linkedGroup.id);
    this.linkedGroups.removeAt(linkedGroupIndex);
    this.filteredLinkedGroups.splice(filteredLinkedGroupIndex, 1);

    if (this.firstPaginatedLinkedGroupIndex > this.filteredLinkedGroups.length) {
      this.changePage();
    }
  }

  public changePage(next?: boolean): void {
    if (next) {
      this.lastPaginatedLinkedGroupIndex += 5;
      this.firstPaginatedLinkedGroupIndex += 5;
      return;
    }

    if (!this.filteredLinkedGroups.length) {
      this.setDefaultPaginate();
      return;
    }

    this.lastPaginatedLinkedGroupIndex -= 5;
    this.firstPaginatedLinkedGroupIndex -= 5;
  }
}
